export default "__VITE_ASSET__DKQXShGS__"